import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
    [action.SET_LCA_TAB](state, data) {
        state.currentLCATab = data;
    },
    [action.GET_LCA_FISCAL_TERMS](state, data) {
        state.lcaFiscalTerms = data;
    },
    [action.GET_LCA_COMPANIES](state, data) {
        state.lcaCompanies = data;
    },
    [action.GET_LCA_DATA](state, data) {
        state.lcaData = data;
    },
    [action.GET_CONSOLIDATED_LCA_DATA](state, data) {
        state.consolidatedLcaData = data;
    },
    [action.SET_FIRST_MONTH_OF_YEAR](state, data) {
        state.firstMonthOfYear = data;
    },
    [action.SET_ACTIVE_AGENDA_UI_TAB](state, data) {
        state.activeAgendaUITab = data;
    },
    [action.MEETING_BY_AGENDA](state, data) {
        state.meetingsByAgenda = data;
    },
    [action.NEW_MEETING_BY_AGENDA](state, data) {
        state.newMeetingsByAgenda = data;
    },
    [action.GET_AGENDA_LIST](state, data) {
        state.agendaList = data;
    },
    [action.GET_AGENDA_BY_ID](state, data) {
        state.agendaDetails = data;
    },
    [action.SET_MEETING_TYPE_FILTER_WIDTH](state, width) {
        state.meetingTypeFilterWidth = width;
    },
    [action.SET_AGENDA_SELECTED_TAB](state, index) {
        state.agendaSelectedTab = index;
    },
    [action.SET_AGENDA_DURATION_FILTER](state, data) {
        state.durationFilter = data;
    },
    [action.GET_MEETING_TYPE_AGENDA_LIST](state, data) {
        state.agendaListByMeetingType = data;
    },
    [action.GET_MEETING_TYPE_AGENDA_LIST_WITH_ARCHIVE](state, data) {
        state.agendaListWithArchive = data;
    },
    [action.AGENDA_MEETING_CHAT](state, data) {
        state.agendaMeetingChatLists = data;
    },
    [action.AGENDA_MEETING_CHAT_PARTICIPANTS](state, data) {
        state.agendaMeetingChatParticipants = data;
    },
    [action.MEETING_CHAT_COMMENTS](state, data) {
        state.meetingChatComments = data;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
    setChatMessages(state, data) {
        state.meetingChatComments = data
    },
    [action.SIGNATURE_PROVIDER](state, data) {
        state.e_signature_provider = data;
    },
    [action.OBSERVER_LIST](state, data) {
        state.observerList = data;
    },
};

export default mutations;
